import axios from 'axios';

let url;
if (process.env.NODE_ENV === 'development') {
    // En desarrollo local, apuntar directamente al backend
    url = process.env.REACT_APP_URL_LOCAL || 'http://localhost:3001';
}
if (process.env.NODE_ENV === 'production') {
    url = process.env.REACT_APP_URL_PRODUCTION;
}

// Si no hay URL configurada, usar relativa (para usar el proxy de Nginx)
const baseURL = url || '/api';

const faradayApi = axios.create({
    baseURL: baseURL
})

faradayApi.interceptors.request.use( config => {

    config.headers = {
        ...config.headers,
        'faraday-token': localStorage.getItem('token') || sessionStorage.getItem('token')
    }
    return config
})

export default faradayApi;
